import { createSelector } from 'reselect';

const getLocalSelectionsRoot = state => state.localSelections;

export const getLocalMerchantSelections = createSelector(
  getLocalSelectionsRoot,
  localSelections => localSelections.merchants,
);
